import { useMutation } from '@apollo/client';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import EntryFormHeader from '../../components/header/EntryFormHeader';
import { RootState } from '../../redux/store';
import { SEND_ENTRY_EMAIL } from '../../graphql/mutations';
import {formatDateTime} from "../../utils/datetime";

interface PersonalEntryFormCompleteType {
}

const PersonalEntryFormComplete: React.FC<PersonalEntryFormCompleteType> = () => {
  const [sendEntryEmail] = useMutation(SEND_ENTRY_EMAIL);
  const entryFormInfo = useSelector((state: RootState) => state.entryForm);

  useEffect(() => {
    
    sendEntryEmail({
      variables: {
        name: entryFormInfo.lastName + entryFormInfo.firstName,
        birthday: entryFormInfo.birthday,
        submissionDate: entryFormInfo.submissionDate,
        externalId: entryFormInfo.externalId,
        email: entryFormInfo.email
      }
    })
  }, []);

  return (
    <>
      <body className="bg-gray-50">
        <EntryFormHeader currentStep={5} />
        <div className="complete-card w-[95%] sm:w-[90%] max-w-[800px] mx-auto p-8 my-8">
          <svg className="check-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>

          <h1 className="text-2xl font-bold mb-4">本人確認を受け付けました</h1>

          <p className="text-gray-600 mb-6">
            本人確認の審査には通常1営業日程度かかります。<br/>
            審査結果はご登録いただいたメールアドレスにお送りいたします。
          </p>

          <div className="status-box">
            <div className="text-center mb-4">
              <div className="text-sm text-gray-500 mb-2">申請状況</div>
              <span className="status-label">審査中</span>
            </div>
            <div className="space-y-2">
              <div className="text-sm">
                <span className="text-gray-500">受付番号：</span>
                <span className="verification-id" id="verificationId">{`${entryFormInfo.externalId}`}</span>
              </div>
              <div className="text-sm">
                <span className="text-gray-500">申請日時：</span>
                <span id="submissionDate">{`${formatDateTime(entryFormInfo.submissionDate)}`}</span>
              </div>
              <div className="text-sm">
                <span className="text-gray-500">メールアドレス：</span>
                <span id="emailAddress">{`${entryFormInfo.email}`}</span>
              </div>
            </div>
          </div>

          <div className="border-t pt-6 mt-6">
            <div className="space-y-4">
              <div className="text-gray-600">
                <h2 className="font-semibold mb-2">審査完了までの流れ</h2>
                <ol className="text-left text-sm space-y-2 mx-auto max-w-md">
                  <li className="flex items-start">
                    <span className="mr-2">1.</span>
                    <span>ご提出いただいた本人確認書類と顔写真などの確認を行います</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">2.</span>
                    <span>確認完了後、審査結果をメールにてお知らせします</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">3.</span>
                    <span>審査に通過した場合、サービスのご利用が可能になります</span>
                  </li>
                </ol>
              </div>

              <div className="text-sm text-gray-500 bg-gray-50 p-4 rounded-md">
                <p className="mb-2">
                  <strong>ご注意：</strong>
                  審査結果のお知らせまでしばらくお待ちください。
                </p>
                <p>
                  審査状況に関するお問い合わせは、上記の受付番号をご用意の上、
                  カスタマーサポートまでご連絡ください。
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-gray-700 font-bold">
              手続きは完了しています。このウィンドウを閉じてください。
            </p>
          </div>
        </div>
      </body>
    </>
  );
};

export default PersonalEntryFormComplete;
